import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import StarBorderIcon from '@mui/icons-material/StarBorder';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import AttachmentIcon from '@mui/icons-material/Attachment';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import ClosedCaptionOutlinedIcon from '@mui/icons-material/ClosedCaptionOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import StayPrimaryPortraitIcon from '@mui/icons-material/StayPrimaryPortrait';

import classes from './ItemsOfTheCourse.module.css';

const ItemsOfTheCourse = props => {
  const { t } = useTranslation(['course']);
  return (
    <aside className={classes.itemsContainer}>
      {parseInt(
        props.dataCourse.aditionalData.positiveRatingPercent
      ) > 50 && (
        <p className={classes.itemDescriptionContainer}>
          <StarBorderIcon className={classes.productIcon} />
          <span className={classes.itemText}>
            {parseInt(
              props.dataCourse.aditionalData.positiveRatingPercent
            )}{' '}
            {t('positive_feedback')} (
            {props.dataCourse.aditionalData.totalReviews})
          </span>
        </p>
      )}
      <p className={classes.itemDescriptionContainer}>
        <GroupOutlinedIcon className={classes.productIcon} />
        <span className={classes.itemText}>
          {t('enrolled_students')}: {props.dataCourse.usersInCourse}
        </span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <MovieOutlinedIcon className={classes.productIcon} />
        <span className={classes.itemText}>
          {props.dataCourse.data.noLecciones} {t('lessons')}
        </span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <AttachmentIcon className={classes.productIcon} />
        <span className={classes.itemText}>
          {
            props.dataCourse.lessonsCourse.lessonExtraInfo
              .lessonActivities.activities
          }{' '}
          {t('activities')}
        </span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <SentimentSatisfiedIcon className={classes.productIcon} />
        <span className={classes.itemText}>{t('online')}</span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <WatchLaterOutlinedIcon className={classes.productIcon} />
        <span className={classes.itemText}>
          {t('duration_of')}{' '}
          {props.dataCourse.lessonsCourse.lessonExtraInfo.lessons
            .seconds /
            60 /
            60}{' '}
          {t('hours')}
        </span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <VolumeUpOutlinedIcon className={classes.productIcon} />
        <span className={classes.itemText}>
          {t('audio')}: Español
        </span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <ClosedCaptionOutlinedIcon className={classes.productIcon} />
        {props.dataCourse.aditionalData.ccData.map(cc => (
          <span key={cc.description} className={classes.itemText}>
            {cc.description},
          </span>
        ))}
      </p>
      <p className={classes.itemDescriptionContainer}>
        <ConfirmationNumberOutlinedIcon
          className={classes.productIcon}
        />
        <span className={classes.itemText}>{t('coupon')}</span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <StayPrimaryPortraitIcon className={classes.productIcon} />
        <span className={classes.itemText}>
          {t('mobile_access')}
        </span>
      </p>
      <p className={classes.itemDescriptionContainer}>
        <figure className={classes.iconContainer}>
          <img
            className={classes.img}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_DiplomaFinalizacion.png"
          />
        </figure>
        <span className={classes.itemTextWithImage}>
          {t('course_diploma')}
        </span>
      </p>
    </aside>
  );
};

ItemsOfTheCourse.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object
};

export default ItemsOfTheCourse;
